import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

import { UNAVAILABLE_MESSAGE, UNAVAILABLE_TITLE } from '../data/constants';
import { DialogService } from '../services/dialog.service';
import { MonitoringService } from '../services/monitoring/monitoring.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const dialogService = inject(DialogService);
  const monitoringService = inject(MonitoringService);

  return next(req).pipe(
    catchError(err => {
      monitoringService.logException(err);
      if (environment.production) {
        console.error(`${err.status} - ${err.name} Message: ${err.message}`);
      } else {
        dialogService.debug_error(`${err.status} - ${err.name}`, `<div>Message: <b>${err.message}</b></div>`);
      }
      if (err.status === 0 || err.status >= 500) {
        dialogService.error(UNAVAILABLE_TITLE, UNAVAILABLE_MESSAGE);
      }
      return throwError(() => err);
    })
  );
};
